import React from "react";

import Title from "../../../../components/Title";
import Editor from "../../../../components/Editor";
import Section from "../../../../components/Section";
import Background from "../../../../components/Background";

import style from "../style.module.css";

export default function Step (props) {
    const {
        currentStep, 
        totalStep, 
        back, 
        image, 
        title, 
        text, 
        children,
        stepName
    } = props;
    return (
        <div className={`${style.stepRow} ${style[`step${currentStep}`]} ${style[stepName] || ""}`}>
            <div className={style.stepImage}>
                <div className={style.stepImageWrap}>
                    <Background src={image} size="1224x2220" cPosition="topLeft" />
                </div>
            </div>
            <div className={style.stepText}>
                <Section className={style.rightSection} center={false}>
                    <div className={style.rightSectionCenter}>
                        <div className={style.stepTextWrapper}>
                            <div className={style.stepInnerRow}>
                                <div className={style.textContentHeader}>
                                    <div className={style.steps}>
                                        {
                                            back !== false && (
                                                <div className={style.backBtn}>
                                                    <p onClick={back}><span className={`${style.dropDown} ${style.left}`}></span> Back</p>
                                                </div>
                                            )
                                        }
                                        <div className={style.stepHeader}>
                                            <Title tag="p">STEP {currentStep}/{totalStep}</Title>
                                            <div className={style.stepTitle}>
                                                <Title tag="p">{title}</Title>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={style.title}>
                                        <Title tag="h3">{title}</Title>
                                    </div>
                                    <div className={style.text}>
                                        <Editor text={text} />
                                    </div>
                                </div>
                                <div className={style.textContentBody}>
                                    {children}
                                </div>
                            </div>
                        </div>
                    </div>
                </Section>
            </div>
        </div>
    )
}